import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { GeoJSONObject } from '@/types/geospatial'
import {
  Classification,
  LayerValue,
  LayerValueFailure,
} from '@/types/weed-diagnosis'

interface Summary {
  classifications: Classification[]
  length_fails: LayerValueFailure
  length_lines: LayerValueFailure
  total_area: LayerValue
}
export interface FailureFeatures {
  layer: string
  geojson: GeoJSONObject
  color: string
}
export const LayerMap: Record<string, string> = {
  '0.5-1.0': '0.5-1.0',
  '1.0-1.5': '1.0-1.5',
  '1.5-2.0': '1.5-2.0',
  '2.0-2.5': '2.0-2.5',
  '2.5-None': '2.5+',
}

export function transformFailures(failures: FailureFeatures[]) {
  return failures.map((failure) => {
    const newLayer =
      failure.layer in LayerMap ? LayerMap[failure.layer] : failure.layer

    return {
      ...failure,
      layer: newLayer,
    }
  })
}

export function transformPlantingFailureData(
  data: GetPlantingFailureSummaryFromDiagnosisResponse,
) {
  if (data.failures) {
    data.failures = transformFailures(data.failures)
  }
  return data
}

export interface GetPlantingFailureSummaryFromDiagnosisResponse {
  summary: Summary
  perimeter: GeoJSONObject
  failures: FailureFeatures[]
}

export async function getPlantingFailureSummaryFromDiagnosis(
  culture: string,
  demandId: string,
  options?: AxiosRequestConfig,
) {
  const { data } =
    await companiesApi.get<GetPlantingFailureSummaryFromDiagnosisResponse>(
      apiRoutes.getSummaryPlantingFailure(culture, demandId),
      options,
    )

  return transformPlantingFailureData(data)
}
